import { EReportType, EReportStatus } from './enum'
import { IPagination } from './common'

// æ¥è¡¨è®¾å®ä¿¡æ¯
export interface IReportSetting {
  id: string, // æ¥è¡¨è®¾å®ä¿¡æ¯ä¸»é®
  rptCd: string, // æ¥è¡¨ä»£ç 
  rptName: string, // æ¥è¡¨åç§°
  rptType: EReportType, // æ¥è¡¨ç±»å
  rptFmt: string, // æä»¶ç±»å
  rptLevel: string, // æ¥è¡¨å±çº§ï¼ææºæãéå¢ãåæ·åé¨åº
  rptLevelCode: string // æ¥è¡¨å±çº§ç¼å·
  rptLevelName: string // æ¥è¡¨å±çº§åç§°
  status: EReportStatus, // æ¥è¡¨ç¶æ
  createdAt: string, // æ¥è¡¨è®¾å®ä¿¡æ¯åå»ºæ¶é´
  updatedAt: string, // æ¥è¡¨è®¾å®ä¿¡æ¯æ´æ°æ¶é´
}

// æ¥è¡¨è®¾å®ä¿¡æ¯åè¡¨åé¡µä¿¡æ¯
export interface IReportSettingPagination extends IPagination {
  data: IReportSetting[],
}

// æ¥è¡¨éç½®ä¿¡æ¯
export interface IReportConfig extends IReportSetting {
  id: string, // æ¥è¡¨éç½®ä¿¡æ¯ä¸»é®
  createdAt: string, // æ¥è¡¨éç½®ä¿¡æ¯åå»ºæ¶é´
  updatedAt: string, // æ¥è¡¨éç½®ä¿¡æ¯æ´æ°æ¶é´
}

// æ¥è¡¨éç½®ä¿¡æ¯åè¡¨åé¡µä¿¡æ¯
export interface IReportConfigPagination extends IPagination {
  data: IReportConfig[],
}

// ä¸è½½æ¥è¡¨é¡µé¢ä¸­çåè¡¨ä¸­çæ¯ä¸è¡è®°å½
export interface IReportReleaseRecord extends IReportConfig {
  id: string, // ä¸»é®
  rptKey: string
  rptCreateTime: string, // çææ¶é´
}

// æ¥è¡¨ä¸è½½åè¡¨åé¡µä¿¡æ¯
export interface IReportReleaseRecordPagination extends IPagination {
  data: IReportReleaseRecord[],
}

export const ReportTypeMap = {
  0: 'REPORT.TYPE.STANDARD', // æ åæ¥è¡¨
  1: 'REPORT.TYPE.CUSTOM', // å®å¶æ¥è¡¨
  2: 'REPORT.TYPE.SELFDEFINED', // èªå®ä¹æ¥è¡¨
}

/** æ¥è¡¨ä¸­çå±çº§å®ä¹ */
export enum EReportLevel {
  Institution = 0,
  Agent = 1,
  Group = 2,
  Store = 3,
}

export const ReportLevelMap = {
  0: 'GENERAL.BIZ_LEVEL.INSTITUTION',
  1: 'GENERAL.BIZ_LEVEL.AGENT',
  2: 'GENERAL.BIZ_LEVEL.MERCHANT',
  3: 'GENERAL.BIZ_LEVEL.STORE',
}
